module.exports = __webpack_public_path__ + "media/images/workplace/patterns/10-42798b965be5c557b2ca021429c9a6ef.png";